import React, { useCallback } from 'react';
import { invokeEventHandler } from '../../../../../helpers/ReactShortcuts';
import StackLayout from '../../../layouts/stackLayout/StackLayoutComponent';
import useTranslation from '../../../../../translation/hooks/UseTranslation';
import useActiveThemeVariation from '../../../../themes/hooks/UseActiveThemeVariation';
import { Search } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import './TextInputImplementation.css';
function resolveInputType(keyboardType, textContentType) {
    if (keyboardType === 'email-address') {
        return 'email';
    }
    if (keyboardType === 'phone-pad') {
        return 'tel';
    }
    if (keyboardType === 'numeric') {
        return 'number';
    }
    if (keyboardType === 'url') {
        return 'url';
    }
    if (textContentType === 'password' || textContentType === 'newPassword') {
        return 'password';
    }
    return 'text';
}
var TextInputImplementation = function (props) {
    var className = props.className, value = props.value, placeholder = props.placeholder, disabled = props.disabled, noTranslation = props.noTranslation, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, onKeyPress = props.onKeyPress, onEnterKeyPress = props.onEnterKeyPress, icon = props.icon, noAutocomplete = props.noAutocomplete, elementName = props.elementName, onPress = props.onPress, testId = props.testId, autocompleteResults = props.autocompleteResults, onAutocompleteResultSelected = props.onAutocompleteResultSelected, isLoading = props.isLoading;
    var hasIcon = icon !== undefined;
    var t = useTranslation().t;
    var activeThemeVariant = useActiveThemeVariation(props, function (x) { return x.coreThemes.textInput; });
    var handleKeyPress = useCallback(function (event) {
        if (onEnterKeyPress && event.key === 'Enter') {
            onEnterKeyPress();
        }
        invokeEventHandler(onKeyPress, event.key);
    }, [onEnterKeyPress, onKeyPress]);
    var handleChange = useCallback(function (event) {
        invokeEventHandler(onChange, event.target.value);
    }, [onChange]);
    var handleSearchChange = useCallback(function (_event, data) {
        invokeEventHandler(onChange, data.value);
    }, [onChange]);
    var handleSearchResultSelected = useCallback(function (_event, data) {
        invokeEventHandler(onAutocompleteResultSelected, data.result);
    }, [onAutocompleteResultSelected]);
    var handleFocus = useCallback(function (e) {
        // disable autocomplete: https://github.com/Semantic-Org/Semantic-UI/issues/6075
        e.target.setAttribute("autocomplete", "nope");
        invokeEventHandler(onFocus);
    }, [onFocus]);
    var TextInputComponent = activeThemeVariant.multiline ? (React.createElement("textarea", { className: hasIcon ? '' : className, style: hasIcon ? { flex: 1 } : undefined, value: value, placeholder: noTranslation ? placeholder === null || placeholder === void 0 ? void 0 : placeholder.toString() : t(placeholder), disabled: disabled, onChange: handleChange, onFocus: onFocus, onBlur: onBlur, onKeyPress: handleKeyPress, rows: activeThemeVariant.numberOfLines, "data-testid": testId })) : onAutocompleteResultSelected ? (React.createElement("div", null,
        React.createElement(Search, { name: elementName, className: hasIcon ? '' : className, style: {
                width: '100%', background: 'transparent'
            }, fluid: true, value: value, placeholder: noTranslation ? placeholder === null || placeholder === void 0 ? void 0 : placeholder.toString() : t(placeholder), disabled: disabled, onSearchChange: handleSearchChange, type: resolveInputType(activeThemeVariant.keyboardType, activeThemeVariant.textContentType), onFocus: handleFocus, onBlur: onBlur, onClick: onPress, onKeyPress: handleKeyPress, onResultSelect: handleSearchResultSelected, "data-testid": testId, results: autocompleteResults, loading: isLoading, icon: null }))) : (React.createElement("input", { name: elementName, className: hasIcon ? '' : className, style: hasIcon ? {
            flex: 1, width: '100%', background: 'transparent'
        } : undefined, value: value, placeholder: noTranslation ? placeholder === null || placeholder === void 0 ? void 0 : placeholder.toString() : t(placeholder), disabled: disabled, onChange: function (e) { return invokeEventHandler(onChange, e.target.value); }, autoComplete: noAutocomplete ? activeThemeVariant.textContentType === 'password' ? 'new-password' : 'no' : 'on', type: resolveInputType(activeThemeVariant.keyboardType, activeThemeVariant.textContentType), onFocus: onFocus, onBlur: onBlur, onClick: onPress, onKeyPress: function (e) {
            if (onEnterKeyPress && e.key === 'Enter') {
                onEnterKeyPress();
            }
            invokeEventHandler(onKeyPress, e.key);
        }, "data-testid": testId }));
    return icon ? (React.createElement(StackLayout, { horizontal: true, className: className },
        activeThemeVariant.iconPosition === 'left' ? icon : null,
        TextInputComponent,
        activeThemeVariant.iconPosition === 'right' ? icon : null)) : (TextInputComponent);
};
export default TextInputImplementation;
//# sourceMappingURL=TextInputImplementation.js.map